export default __webpack_public_path__ + "static/media/20210430_235850-min.326cefcf.jpg";